
import UserAPIService from '@/modules/users/services/apiService'

export default class UserModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.userService = new UserAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/modules/users/views/userList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Users',
          menuLink: '/users',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/users/new',
        name: 'New User',
        component: () => import('@/modules/users/views/userNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New User',
          menuLink: '/users',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Users', link: '/user' }
          ],
        }
      },
      {
        path: '/users/archived',
        name: 'Archived Users',
        component: () => import('@/modules/users/views/userList.vue'),
        props: {
          filterType: 'archived'
        },
        meta: {
          requiresAuth: true,
          title: 'Archived Users',
          menuLink: '/users/archived',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/users/:id(\\d+)',
        name: 'User',
        component: () => import('@/modules/users/views/user.vue'),
        meta: {
          requiresAuth: true,
          title: 'User',
          menuLink: '/users',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Users', link: '/users'}
          ],
        }
      },
      {
        path: '/users/profile',
        name: 'UserProfile',
        component: () => import('@/modules/users/views/userProfile.vue'),
        meta: {
          requiresAuth: true,
          title: 'My Profile',
          menuLink: '/users',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      
  
      // User Groups
      {
        path: '/users/groups',
        name: 'User Groups',
        component: () => import('@/modules/users/views/userGroupList.vue'),
        meta: {
          requiresAuth: true,
          title: 'User Groups',
          menuLink: '/users/groups',
          breadcrumbs: [
              { title: 'Home', link: '/'}
          ],
        }
      },
      {
        path: '/users/groups/new',
        name: 'New User Group',
        component: () => import('@/modules/users/views/userGroupNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New User Group',
          menuLink: '/usergroups',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'User Groups', link: '/users/groups' }
          ],
        }
      },
      {
        path: '/users/groups/:id(\\d+)',
        name: 'User Group',
        component: () => import('@/modules/users/views/userGroup.vue'),
        meta: {
          requiresAuth: true,
          title: 'User Group',
          menuLink: '/users/groups',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'User Groups', link: '/users/groups' }
          ],
        }
      }
    ]
  }
}